<template>
  <div class="flex-grow-1">
    <header-bar />
    <v-card>
      <v-card-text class="ml-4">
        <div class="h1 mb-2">Privacy Policy</div>
        <div class="ml-4">
          <div class="h2 mb-4">Last Updated: July 22, 2024</div>
          <div class="h2">I. Introduction</div>
          <div class="body mb-2">
            Welcome to Sigflō. We are committed to protecting your privacy. This
            Privacy Policy explains how we collect, use, and disclose
            information about you when you use our website and services related
            to Sigflō
          </div>
          <div class="h2">II. Information We Collect</div>
          <div class="body">
            We collect information about you in various ways when you use our
            website:
          </div>
          <div class="body mb-2">
            <ul>
              <li>
                <b>Personal Information:</b> We collect personal information you
                provide to us, such as your name, email address, phone number,
                and company details.
              </li>
              <li>
                <b>Project and Event Data:</b> We collect data related to the
                projects and events you manage using our website, including
                details of audio, video, and lighting requirements.
              </li>
              <li>
                <b>Usage Information:</b> We collect information about your
                usage of our website and services, such as your IP address,
                browser type, and access times.
              </li>
            </ul>
          </div>
          <div class="h2">III. How We Use Your Information</div>
          <div class="body">
            We use the information we collect for various purposes, including:
          </div>
          <div class="body mb-2">
            <ul>
              <li>Providing, maintaining, and improving our website.</li>
              <li>
                Communicating with you about products, services, and promotional
                offers.
              </li>
              <li>Personalizing your experience on our website.</li>
              <li>
                Analyzing usage and trends to improve our website and services.
              </li>
              <li>
                Complying with legal obligations and protecting our legal
                rights.
              </li>
            </ul>
          </div>
          <div class="h2">IV. How We Share Your Information</div>
          <div class="body">
            We do not share your personal information with third parties except
            as described in this Privacy Policy or as required by law:
          </div>
          <div class="body mb-2">
            <ul>
              <li>
                <b>Service Providers:</b> We may share your information with
                third-party service providers who perform services on our
                behalf, such as data analysis, payment processing, and customer
                support.
              </li>
              <li>
                <b>Legal Compliance:</b> We may disclose your information if
                required to do so by law or in response to valid requests by
                public authorities.
              </li>
              <li>
                <b>Business Transfers:</b> If we are involved in a merger,
                acquisition, or sale of assets, your information may be
                transferred as part of that transaction.
              </li>
            </ul>
          </div>
          <div class="h2">V. Data Security</div>
          <div class="body mb-2">
            We take reasonable measures to protect the information we collect
            from unauthorized access, use, or disclosure. However, no method of
            transmission over the internet or electronic storage is completely
            secure.
          </div>
          <div class="h2">VI. Your Choices</div>
          <div class="body">
            You have the following choices regarding your information:
          </div>
          <div class="body mb-2">
            <ul>
              <li>
                <b>Access and Correction:</b> You may request access to or
                correction of your personal information by contacting us.
              </li>
              <li>
                <b>Opt-Out:</b> You may opt-out of receiving promotional
                communications from us by following the instructions in those
                communications or contacting us directly.
              </li>
            </ul>
          </div>
          <div class="h2">VII. Cookies and Tracking Technologies</div>
          <div class="body mb-2">
            We use cookies and similar tracking technologies to collect
            information about your interactions with our website. You can manage
            your cookie preferences through your browser settings.
          </div>
          <div class="h2">VIII. Third-Party Links</div>
          <div class="body mb-2">
            Our website may contain links to third-party websites. We are not
            responsible for the privacy practices or content of those websites.
          </div>
          <div class="h2">IX. Changes to This Privacy Policy</div>
          <div class="body mb-2">
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on our website.
            Your continued use of our website after such changes constitutes
            your acceptance of the updated Privacy Policy.
          </div>
          <div class="h2">X. Contact Us</div>
          <div class="body mb-2">
            If you have any questions or concerns about this Privacy Policy,
            please <RouterLink to="/contact"> contact us </RouterLink>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <footer-bar />
  </div>
</template>

<script>
  import headerBar from '@/components/shared/HeaderBar.vue';
  import footerBar from '@/components/shared/FooterBar.vue';

  export default {
    components: {
      headerBar,
      footerBar
    }
  };
</script>

<style scoped>
  .h1 {
    color: black;
    font-size: 2rem;
    line-height: 2;
    font-weight: bold;
  }
  .h2 {
    font-size: 1rem;
    font-weight: bold;
    color: black;
  }
  .body {
    font-weight: normal;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.7);
  }
</style>
